import {
  Menu,
  Transition,
  MenuButton,
  MenuItems,
  MenuItem,
} from "@headlessui/react";
import { useSession } from "@/hooks/useSession";
import { signOut } from "@/services/authService";

function classNames(...classes: string[]) {
  return classes.filter(Boolean).join(" ");
}

/**
 * User authentication dropdown menu.
 * Shows user initials and provides sign out functionality.
 */
export function AuthDropdown() {
  const { data: session, isAuthEnabled } = useSession();

  if (!isAuthEnabled) {
    return null;
  }

  const initials = session?.user?.name?.split(" ").map((n) => n[0]);

  return (
    <Menu as="div" className="relative ml-3">
      <div>
        <MenuButton className="flex rounded-full text-sm">
          <span className="sr-only">Open user menu</span>
          <span className="relative m-1 mr-2 flex h-12 w-12 items-center justify-center rounded-full bg-[#0ec3a4] text-xl text-white uppercase hover:bg-[#0b9c83]">
            {initials}
          </span>
        </MenuButton>
      </div>
      <Transition
        enter="transition ease-out duration-100"
        enterFrom="transform opacity-0 scale-95"
        enterTo="transform opacity-100 scale-100"
        leave="transition ease-in duration-75"
        leaveFrom="transform opacity-100 scale-100"
        leaveTo="transform opacity-0 scale-95"
      >
        <MenuItems className="absolute right-0 mt-2 w-48 origin-top-right rounded-md bg-white py-1 shadow-lg ring-1 ring-black/5 focus:outline-none">
          <MenuItem>
            {({ active }) => (
              <button
                type="button"
                onClick={() => void signOut()}
                className={classNames(
                  active ? "bg-[#f7fafc]" : "",
                  "block w-full px-4 py-2 text-left text-sm text-[#4a5568]",
                )}
              >
                Sign out
              </button>
            )}
          </MenuItem>
        </MenuItems>
      </Transition>
    </Menu>
  );
}
